import React from 'react';

const ContainerFilterButtons = ({ disabled, filter, setFilter }) => {
  return (
    <>
      <button
        className={`${!disabled && filter == 'active' ? 'selected' : ''} blue`}
        onClick={() => setFilter('active')}
        disabled={disabled}
      >
        Active Containers
      </button>
      <button
        className={`${!disabled && filter == 'all' ? 'selected' : ''} blue`}
        onClick={() => setFilter('all')}
        disabled={disabled}
      >
        All Containers
      </button>
      <button
        className={`${!disabled && filter == 'roles' ? 'selected' : ''} blue`}
        onClick={() => setFilter('roles')}
        disabled={disabled}
      >
        Existing Roles
      </button>
    </>
  );
};

export default ContainerFilterButtons;
